import { useParams, useNavigate } from "react-router-dom";
import { DanceStyleUpdateForm } from "../../ui-components";
import { Flex, Heading, Link } from "@aws-amplify/ui-react";
import { Helmet } from "react-helmet";
import { I18n } from "aws-amplify/utils";
import { FaArrowLeft } from "react-icons/fa6";

export default function DanceStyleUpdate() {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <Flex direction="column" gap="1rem">
      <Helmet>
        <title>{I18n.get("Edit Dance Style")}</title>
      </Helmet>
      <Flex marginTop={"1rem"}>
        <Heading level={1}>{I18n.get("Edit Dance Style")}</Heading>
      </Flex>
      <Flex>
        <Link onClick={() => navigate(-1)}>
          <FaArrowLeft aria-label={I18n.get("Back")} />
        </Link>
      </Flex>
      <Flex>
        <DanceStyleUpdateForm id={id} onSuccess={() => navigate(-1)} />
      </Flex>
    </Flex>
  );
}
